/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="55.5"
        height="95.58"
        viewBox="0 0 55.5 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M49.07 0H6.48A6.41 6.41 0 0 0 .07 6.41v82.74a6.42 6.42 0 0 0 6.4 6.42h42.6a6.41 6.41 0 0 0 6.42-6.4V6.42A6.41 6.41 0 0 0 49.07 0ZM6.48 2.5h42.59a3.91 3.91 0 0 1 3.92 3.92v82.74a3.91 3.91 0 0 1-3.9 3.92H6.48a3.92 3.92 0 0 1-3.92-3.9V6.42A3.92 3.92 0 0 1 6.48 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M54.18 12.92a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22h-53A1.25 1.25 0 0 1 0 14.22a1.24 1.24 0 0 1 1.18-1.31h53ZM54.18 77.56a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22h-53A1.25 1.25 0 0 1 0 78.86a1.24 1.24 0 0 1 1.18-1.31h53ZM33.92 6.71a1 1 0 0 1 1.06.94 1 1 0 0 1-.94 1.06H21.63a1 1 0 0 1-1.06-.94 1 1 0 0 1 .94-1.06Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M27.75 53.12a9.7 9.7 0 0 1 6.57 2.6 1.253 1.253 0 1 1-1.69 1.85 7.08 7.08 0 0 0-9.76 0 1.253 1.253 0 0 1-1.69-1.85 9.72 9.72 0 0 1 6.57-2.6ZM27.75 44.1a18.22 18.22 0 0 1 12.77 5.25 1.25 1.25 0 1 1-1.64 1.88l-.1-.09a15.66 15.66 0 0 0-22.06 0 1.25 1.25 0 1 1-1.83-1.7l.09-.09a18.24 18.24 0 0 1 12.77-5.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M27.75 35.08A26.78 26.78 0 0 1 46.69 43a1.24 1.24 0 0 1 .11 1.76 1.26 1.26 0 0 1-1.77.11l-.1-.1a24.17 24.17 0 0 0-34.18-.18l-.18.18a1.25 1.25 0 0 1-1.86-1.67l.1-.1a26.8 26.8 0 0 1 18.94-7.92Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M27.75 90.14a3.58 3.58 0 1 1 3.58-3.58 3.59 3.59 0 0 1-3.58 3.58"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'MobileDeviceWithWifiSymbolIcon';

export default Icon;
